// extracted by mini-css-extract-plugin
export var cardSelected = "_dt-2";
export var image = "_dt-1";
export var table = "_dt-0";